export const Display = ({ onShowText }) => {
  return <div id="display">{onShowText}</div>;
};
